<div class="p-6 bg-gray-50 rounded-lg shadow-lg" *transloco="let t">
  <!-- Data Inicial e Final, e Select de Status -->
  <div class="flex space-x-4 mb-4">
    <div class="flex-1">
      <input type="text" [(ngModel)]="orderId" class="block w-full p-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500" />
    </div>
    <!-- Campo de Data Inicial -->
    <div class="flex-1">
      <label for="dataInicial" class="block text-sm font-medium text-gray-700">{{ t('orders.startDate') }}</label>
      <input type="date" id="dataInicial" name="dataInicial" [(ngModel)]="dataInicial"
        class="block w-full p-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500" />
    </div>

    <!-- Campo de Data Final -->
    <div class="flex-1">
      <label for="dataFinal" class="block text-sm font-medium text-gray-700">{{ t('orders.endDate') }}</label>
      <input type="date" id="dataFinal" name="dataFinal" [(ngModel)]="dataFinal"
        class="block w-full p-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500" />
    </div>

    <!-- Select para filtro de status -->
    <div class="flex-1">
      <label for="statusEnvio" class="block text-sm font-medium text-gray-700">{{ t('orders.shippingStatus') }}</label>
      <select id="statusEnvio" (change)="onStatusChange($event)"
        class="block w-full p-2 h-11 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500">
        <option value="">{{ t('orders.status.all') }}</option>
        <option value="pending">{{ t('orders.status.pending') }}</option>
        <option selected value="ready_to_ship">{{ t('orders.status.readyToShip') }}</option>
        <option value="shipped">{{ t('orders.status.shipped') }}</option>
        <option value="delivered">{{ t('orders.status.delivered') }}</option>
        <option value="not_delivered">{{ t('orders.status.notDelivered') }}</option>
        <option value="cancelled">{{ t('orders.status.cancelled') }}</option>
        <option value="in_transit">{{ t('orders.status.inTransit') }}</option>
      </select>
    </div>
  </div>

  <!-- Botões de Ações -->
  <div class="flex justify-end space-x-2 mb-4">
    <button class="bg-gray-500 text-white px-4 py-2 rounded-md hover:bg-gray-600 transition duration-200">
      {{ t('orders.clear') }}
    </button>
    <button (click)="search()" class="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition duration-200">
      {{ t('orders.search') }}
    </button>
  </div>

  <!-- Tabela de Pedidos -->
  <div class="overflow-x-auto bg-white p-6 rounded-lg shadow-lg">
    <h2 class="text-xl font-bold mb-4">{{ t('orders.totalOrders') }} {{ totalOrders }}</h2>

    <!-- Status de Impressão -->
    <div class="flex items-center space-x-2 mb-4">
      <button [disabled]="!printerStatus.status"
        class="bg-blue-500 text-white p-2 rounded-full w-10 h-10 flex items-center justify-center hover:bg-blue-600 transition duration-200"
        (click)="print()" [title]="!printerStatus.status ? t('orders.printerOffline') : t('orders.print')">
        <i class="fas fa-print"></i>
      </button>
      <span *ngIf="!printerStatus.status" class="text-red-500">{{ t('orders.printerOffline') }}</span>
    </div>

    <!-- Carregando... -->
    <span *ngIf="loading" class="flex items-center mb-4">
      <i class="fas fa-spinner fa-spin mr-2"></i>
      <span class="text-gray-500">{{ printing ? printingMessage : t('orders.loadingWait') }}</span>
    </span>

    <!-- Tabela -->
    <table class="min-w-full table-auto divide-y divide-gray-200">
      <thead class="bg-gray-100">
        <tr>
          <th class="px-2 py-2">
            <input type="checkbox" [title]="t('orders.selectAll')" [(ngModel)]="selectAll" (change)="toggleSelectAll()"
              class="h-4 w-4 text-indigo-600 border-gray-300 rounded">
          </th>
          <th class="px-2 py-2 text-left text-xs font-medium text-gray-500">{{ t('orders.col.id') }}</th>
          <th class="px-2 py-2 text-left text-xs font-medium text-gray-500">{{ t('orders.col.product') }}</th>
          <th class="px-2 py-2 text-left text-xs font-medium text-gray-500">{{ t('orders.col.attributes') }}</th>
          <th class="px-2 py-2 text-left text-xs font-medium text-gray-500">{{ t('orders.col.sku') }}</th>
          <th class="px-2 py-2 text-left text-xs font-medium text-gray-500">{{ t('orders.col.status') }}</th>
          <th class="px-2 py-2 text-left text-xs font-medium text-gray-500">{{ t('orders.col.manufacturingEnd') }}</th>
          <th class="px-2 py-2 text-left text-xs font-medium text-gray-500">{{ t('orders.col.price') }}</th>
          <th class="px-2 py-2 text-left text-xs font-medium text-gray-500">{{ t('orders.col.quantity') }}</th>
        </tr>
      </thead>
      <tbody class="bg-white divide-y divide-gray-200">
        <tr *ngFor="let order of orders; let i = index" (click)="toggleCheckbox(i)" class="hover:bg-gray-100 cursor-pointer">
          <td class="px-2 py-2 text-center">
            <input type="checkbox" [(ngModel)]="order.checked"
              class="h-4 w-4 text-indigo-600 border-gray-300 rounded">
          </td>
          <td class="px-2 py-2">{{order.id}}</td>
          <td class="px-2 py-2">{{ order.order_items[0].item.title }}</td>
          <td class="px-2 py-2">
            <span *ngFor="let attr of order.order_items[0].item.variation_attributes"
              class="inline-flex items-center bg-gray-100 text-gray-600 text-xs font-medium px-2 py-1 rounded-md ring-1 ring-gray-200 mr-2">
              <div class="truncate" title="{{ attr.name }}: {{ attr.value_name }}">{{ attr.name }}: {{ attr.value_name }}</div>
            </span>
          </td>
          <td class="px-2 py-2">{{ order.order_items[0].item.seller_sku }}</td>
          <td class="px-2 py-2">{{ order.status }}</td>
          <td class="px-2 py-2">{{ order.manufacturing_ending_date | date: 'dd/MM/yyyy HH:mm' }}</td>
          <td class="px-2 py-2">R$ {{ order.paid_amount.toFixed(2) }}</td>
          <td class="px-2 py-2">{{ order.order_items[0].requested_quantity.value }} {{ t('orders.units') }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
